

import React from 'react';
import { Format1, BillSupply, Letter, BTST1, SBP } from "../../../../../../Shared/components/InvoiceModal/DeliveryTemplates";
import clsx from "clsx";

export const BillFormat = React.forwardRef((props, ref) => {
    const { details, classes, keyVal } = props;



    const previewFormat = () => {
        switch (details?.selfBill?.billFormat) {
            case "format1": return <Format1 ref={ref} format={details?.selfBill?.billFormat} {...props} />;
            case "btst-1": return <BTST1 ref={ref} format={details?.selfBill?.billFormat} {...props} />;
            case "billSupply": return <BillSupply ref={ref} format={details?.selfBill?.billFormat}  {...props} />;
            case "letter": return <Letter ref={ref} format={details?.selfBill?.billFormat}  {...props} />;
            case "SBP": return <SBP ref={ref} format={details?.selfBill?.billFormat}  {...props} />;
            default: return <SBP ref={ref} format={details?.selfBill?.billFormat}  {...props} />;
        }
    }

    return (
        <>
            {
                keyVal > 0 ? <div className="page-break"></div> : ''
            }
            <div className={clsx(classes.printFullPage)} data-invoiceid={details?.serialNo}>
                {previewFormat()}
            </div>

        </>
    )
})